import ProjectInvoice from './project-invoice';
import { Adjustment } from '../project/adjustment';
import Company from '../company/company';

export default class AdjustmentInvoice extends ProjectInvoice {
  adjustment?: Adjustment;

  constructor(company?: Company) {
    super(company);
    this.type = 'AdjustmentInvoice';
  }
}
